/**
 * Shared constants for registration forms
 */
/**
 * The ID of the current event being registered for.
 * TODO: This might need to be dynamic or fetched from configuration in the future.
 */
export const EVENT_ID = 'c1115900-d317-437f-81f5-4608c730563c';
/**
 * School Registrant Role options
 * Used across all registration forms for consistency
 */
export const ROLE_OPTIONS = [
    { value: '', label: 'Select option' },
    { value: 'educator', label: 'Educator' },
    { value: 'administrator', label: 'Administrator' },
    { value: 'other', label: 'Other' },
];
/**
 * Grade level options
 * Used across all registration forms
 */
export const GRADE_LEVELS = [
    { value: 'Grades 6', label: 'Grades 6' },
    { value: 'Grades 7', label: 'Grades 7' },
    { value: 'Grades 8', label: 'Grades 8' },
    { value: 'Grades 9', label: 'Grades 9' },
    { value: 'Grades 10', label: 'Grades 10' },
    { value: 'Grades 11', label: 'Grades 11' },
    { value: 'Grades 12', label: 'Grades 12' },
];
/**
 * Referral type options
 * How users heard about the challenge
 * Used across all registration forms
 */
export const REFERRAL_TYPE_OPTIONS = [
    { value: '', label: 'Select option' },
    { value: 'email', label: 'Email' },
    { value: 'social-media', label: 'Social Media' },
    { value: 'org1', label: 'Org 1' },
    { value: 'org2', label: 'Org 2' },
    { value: 'org3', label: 'Org 3' },
    { value: 'org4', label: 'Org 4' },
    { value: 'org5', label: 'Org 5' },
    { value: 'org6', label: 'Org 6' },
    { value: 'org7', label: 'Org 7' },
    { value: 'org8', label: 'Org 8' },
    { value: 'org9', label: 'Org 9' },
    { value: 'org10', label: 'Org 10' },
    { value: 'other', label: 'Other' },
];
